import React from 'react';
import { Stack, Text } from 'library/ui';

const CLEARINGHOUSE_LINK = 'https://crw.flclearinghouse.com/';

export function FloridaClearinghouseNotice() {
    return (
        <Stack gap="md">
            <Text weight="bold">Important: New Process for Booking Substitutes</Text>
            <Text size="sm" component="p" lineHeight="relaxed">
                Based on guidance from the Florida Department of Early Learning (DEL) and the Department of Children and
                Families (DCF), booking a substitute now requires a few extra steps from your center:
            </Text>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
                <li>
                    <Text size="sm" lineHeight="relaxed">
                        We will notify you when a substitute applies to your shift. To book them, verify that they have
                        an eligible background check in the{' '}
                        <a href={CLEARINGHOUSE_LINK} target="_blank" rel="noreferrer">
                            FL Clearinghouse
                        </a>{' '}
                        and confirm with Tandem.
                    </Text>
                </li>
                <li>
                    <Text size="sm" lineHeight="relaxed">
                        Add the substitute to your Clearinghouse roster before they work at your center.
                    </Text>
                </li>
                <li>
                    <Text size="sm" lineHeight="relaxed">
                        If a substitute has not worked at your center in the last 90 days, you will need to verify their
                        record again before they can be booked.
                    </Text>
                </li>
            </ul>
            <Text size="sm" component="p" lineHeight="relaxed">
                For questions, please contact team@join-tandem.com or call (614) 907-4374.
            </Text>
        </Stack>
    );
}
